import { render, staticRenderFns } from "./InboundDeliveryDetails.vue?vue&type=template&id=a0872f22"
import script from "./InboundDeliveryDetails.vue?vue&type=script&lang=js"
export * from "./InboundDeliveryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0872f22')) {
      api.createRecord('a0872f22', component.options)
    } else {
      api.reload('a0872f22', component.options)
    }
    module.hot.accept("./InboundDeliveryDetails.vue?vue&type=template&id=a0872f22", function () {
      api.rerender('a0872f22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/InboundDeliveryDetails.vue"
export default component.exports